import { saveSessionItem, clearSessionItem } from './utilsSessionStorageApi';
import {saveItem, clearItem} from './utilsLocalStorageApi';

const logNewTab = () => {
    //adding new tab entry into storage
    const sessionTabs = filterObjectByKeyName('tab_', sessionStorage);
    if (Object.keys(sessionTabs).length > 0)
      removeTabsFromStorage(sessionTabs);
    const hash = Date.now();
    saveSessionItem(`tab_${hash}`, true);
    saveItem(`tab_${hash}`, true);
};

const removeTabsFromStorage = (tabs = {}) => {
    for (const key in tabs) {
      if (tabs.hasOwnProperty(key)) {
        clearItem(key);
        clearSessionItem(key);
      }
    }
  };

const filterObjectByKeyName = (substring, object) => {
    const filteredObject = Object.keys(object)
      .filter(function(key) {
        return key.indexOf(substring) === 0;
      })
      .reduce(function(newData, key) {
        newData[key] = object[key];
        return newData;
      }, {});
    return filteredObject;
};

const utilsGetOrgNameFromId = (orgId, proxyOrgList = [], defaultOrgID, defaultOrgName) => {
  const orgObj = proxyOrgList.find(proxyOrg => proxyOrg['orgID'] == orgId);
  const orgName = (orgObj && orgObj.orgName) || orgId;
  if (orgName === defaultOrgID){
    return defaultOrgName;
  }
  return orgName;
};

const tabBeforeUnloadEventHandler = () => {
  const sessionTabs = filterObjectByKeyName('tab_', sessionStorage);
  removeTabsFromStorage(sessionTabs);
};

const utilsHandleStorageChange = (e, requiredKey) => {
  const { oldValue, newValue, key: changedKey} = e;
  if( changedKey === requiredKey && oldValue && newValue && oldValue !== newValue ){
    return true;
  }
  return false;
}

const isMultipleTabsOpen = () => {
  const openTabs = filterObjectByKeyName('tab_', localStorage);
  if (Object.keys(openTabs).length > 1){
    return true;
  }
  return false;
}

export default {
  logNewTab,
  removeTabsFromStorage,
  filterObjectByKeyName,
  utilsGetOrgNameFromId,
  tabBeforeUnloadEventHandler,
  utilsHandleStorageChange,
  isMultipleTabsOpen
}